import { ROLE } from '@cmoh/shared'
import type { AppRoute } from '@/lib/routing/routing.types'
import { lazyWithRetry } from '@/lib/utils/lazy-with-retry'

const BulkGenerationPage = lazyWithRetry(() => import('./components/BulkGenerationPage').then(module => ({ default: module.BulkGenerationPage })))
const BulkJobProgressPage = lazyWithRetry(() => import('./components/BulkJobProgressPage').then(module => ({ default: module.BulkJobProgressPage })))

const routes: AppRoute[] = [
  {
    path: 'content/bulk',
    element: BulkGenerationPage,
    meta: { title: 'bulkGeneration.routes.bulkGeneration', require: { minRole: ROLE.MEMBER } },
  },
  {
    path: 'content/bulk/:jobId',
    element: BulkJobProgressPage,
    meta: { title: 'bulkGeneration.routes.bulkJobProgress', require: { minRole: ROLE.MEMBER } },
  },
]

export default routes
